module.exports = __webpack_public_path__ + "img/product16p.a39319b7.png";